import type { HTMLAttributes } from "react";
import { cn } from "../helpers/class-names";

export type BadgeTone = "neutral" | "success" | "danger" | "warning";
type BadgeProps = HTMLAttributes<HTMLSpanElement> & { tone?: BadgeTone };

export function Badge({ className, tone = "neutral", ...props }: BadgeProps) {
  return (
    <span
      className={cn("ui-badge", `ui-badge--${tone}`, className)}
      {...props}
    />
  );
}
